import { FeatureFlags, useFeatureFlag } from '~/utils/featureflags';

import { useScanDetection } from '../hooks/useScanDetection';
import { useScanEventProcessor } from '../hooks/useScanEventProcessor';

const ScanDetectionListener = () => {
  useScanEventProcessor();
  useScanDetection();

  return null;
};

export const ScanDetectionMonitor = () => {
  const isScanDetectionEnabled =
    useFeatureFlag(FeatureFlags.QUICKPACK_SCAN_TO_PRINT)?.enabled ?? false;

  if (!isScanDetectionEnabled) return null;

  return <ScanDetectionListener />;
};
